import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '../interfaces/api-response';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestApiService {
  
    constructor(private http: HttpClient) {}

    async auth(keycloakToken: any) : Promise<ApiResponse> {
        const body = {token: keycloakToken};
        return this.http.post<ApiResponse>(environment.appBackUrl + '/mmlPatient/check_token', body).toPromise();
    }

    async authClient(ref: any) : Promise<ApiResponse> {
        //const body = {ref: btoa(ref)};
        const body = {ref: ref};
        return this.http.post<ApiResponse>(environment.appBackUrl + "/mmlPatient/check_ref", body).toPromise();
    }

    async checkOtpPatient(ref: string, otp: string) : Promise<ApiResponse> {
        const body = {'ref': ref, 'otp': otp};
        return this.http.post<ApiResponse>(environment.appBackUrl + '/mmlPatient/check_otp', body).toPromise();
    }

    async checkRefPatient(ref: string, email: string) : Promise<ApiResponse> {
        const body = {'ref': ref, 'email': email};
        return this.http.post<ApiResponse>(environment.appBackUrl + '/mmlPatient/check_user_ref', body).toPromise();
    }

    askOtp(ref: string): Observable<ApiResponse> {
        const body = {ref:ref};
        return this.http.post<ApiResponse>(environment.appBackUrl + '/mmlPatient/send_otp', body);
        
    }

    async refreshApiToken(refreshTokenApi: string) : Promise<any> {
        const body = {'refresh_token': refreshTokenApi};
        return this.http.post<any>(environment.appBackUrl + "/api/token/refresh", body).toPromise();
    }

    async logout(refreshTokenApi: string): Promise<ApiResponse> {
        const body = {'refreshToken': refreshTokenApi};
        return this.http.post<ApiResponse>(environment.appBackUrl + "/mmlPatient/logout", body).toPromise();
    }
}
